import { Dialog } from 'evergreen-ui';
import EditVolunteerForm from './EditVolunteerForm';

const EditVolunteerDialog = ({
    isShown,
    onClose,
    volunteer,
    fetchVolunteers
}) => {
    return (
        <Dialog
            isShown={isShown}
            title="Modifica volontario"
            onCloseComplete={onClose}
            hasFooter={false}
        >
            {volunteer && (
                <EditVolunteerForm
                    volunteer={volunteer}
                    onClose={onClose}
                    fetchVolunteers={fetchVolunteers}
                />
            )}
        </Dialog>
    );
};

export default EditVolunteerDialog;